<template>
    <div class="d-flex flex-column align-items-center px-4 py-3">
        <img alt="" src="/img/hcpay/thank-you.svg" class="thankYouIcon img-responsive">
        <span class="font-md font-weight-bold text-gray-dk my-3">Thank you!</span>
        <span class="col-9 font-sm text-secondary mb-5 text-center">Your feedback will help us make better products.</span>
        <div class="col-10 p-0">
            <button type="button" class="btn btn-success btn-block rounded-lg font-sm py-2" @click="backToStore">Back to Store</button>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        backToStore() {
            let g4params = {
                'userId': sessionStorage.getItem("userId"),
                'cuid': sessionStorage.getItem("cuid"),
                'ip': sessionStorage.getItem("ip"),
                'user_agent': sessionStorage.getItem("user_agent"),
                'phone': sessionStorage.getItem("phone"),
                'operating_system': sessionStorage.getItem("operating_system"),
                'browser': sessionStorage.getItem("browser"),
                'transaction_type': sessionStorage.getItem("transaction_type"),
                'transaction_reference': sessionStorage.getItem("transaction_reference"),
            }       
            this.triggerG4Event('feedback_complete_click_back_to_store',g4params)
            // sessionStorage.clear();
            this.$attrs.options.promiseResolver();
        },
        triggerG4Event(name, params = {}){
            if (typeof gtag === 'function'){
                gtag("event", name , params)
            } else{
                console.log('GTAG Func Not Defined')
            }
        }
    }
}
</script>
<style scoped>
    .thankYouIcon {
        height: auto;
        width: 10rem;
    }
</style>